export default __webpack_public_path__ + "static/media/green_icon.0fcaf78c.svg";